import { Commit, ActionTree } from 'vuex';
import { State } from './endpoints.store';
import graphQl from '@/services/graphQl';
import { AxiosResponse } from 'axios';

const actions: ActionTree<State, any> = {
  async GET_ALL_GROUPS(
    context: { commit: Commit; rootState: any },
    params: any
  ) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('getAllGroupsList')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.AllGroups;
        } else return [];
      });
  },
  async DELETE_GROUP(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('deleteGroupInPulse')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.PulseGroupResponse;
        } else return [];
      });
  },
  async GET_GROUP_ALERTS(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('getGroupAlerts')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.PulseGroupResponse;
        } else return [];
      });
  },
  async DELETE_ENDPOINT(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('deleteEGKPM')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.response;
        } else return [];
      });
  },
  async SAVE_GROUP(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('createGroupInPulse')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.PulseGroupResponse;
        } else return [];
      });
  },
  async GET_ALL_GROUPS_LIST(
    context: { commit: Commit; rootState: any },
    params: { serviceReq: any; duration: any }
  ): Promise<any> {
    return graphQl
      .query('getPulseListGroupCards')
      .params(params)
      .then(async (res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.GroupCardsResponse;
        } else {
          return [];
        }
      });
  },
  async SAVE_ENDPOINT(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('addEndpoint')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.addingEndpoint;
        } else return [];
      });
  },
  async FETCH_ENDPOINT_DETAIL(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('fetchEndpointDetail')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.PulseInfoResponse;
        } else return [];
      });
  },
  selectEndpoint(context: { commit: Commit }, params: any) {
    context.commit('setCurrentEndpointId', params);
  },
  async SAVE_SCHEDULE_TEST(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('postScheduleTest')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.response;
        } else return [];
      });
  },
  async PAUSE_RESUME_DAG(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('pauseResumeScheduleAirflow')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.CommonInfoResponse;
        } else return [];
      });
  },
  async FETCH_AIRFLOW_SCHEDULE(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('fetchAirflowScheduleInfo')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.response;
        } else return [];
      });
  },
  async RELOAD_TEST_STATUS(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('getRefreshTestStatus')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.response;
        } else return [];
      });
  },
  async LIST_TEST_PLAN_IDS(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('getTestPlanIds')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.response;
        } else return [];
      });
  },
  async GET_ACCESS_TOKEN(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('getAuthToken')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.response;
        } else return [];
      });
  },
  async SAVE_OAUTH2_TOKEN(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('saveOauthToken')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.saveAuthToken;
        } else return [];
      });
  },
  async VALIDATE_OAUTH2_TOKEN(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('validateOauthToken')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.secretresp;
        } else return [];
      });
  }
};

export default actions;
